import React from "react";

import styled from "styled-components";

const ModalFooterLayout: React.FC<{
  isDefaultModal?: boolean;
  leftFooterElements?: React.ReactElement;
}> = function ModalFooterLayout({
  isDefaultModal,
  leftFooterElements,
  children,
}) {
  return (
    <StyledModalFooterWrapper
      leftFooterElements={leftFooterElements}
      isDefaultModal={isDefaultModal}
    >
      <>{leftFooterElements}</>
      <StyledButtonWrapper>{children}</StyledButtonWrapper>
    </StyledModalFooterWrapper>
  );
};
export default ModalFooterLayout;
const StyledModalFooterWrapper = styled.div<{
  leftFooterElements?: React.ReactElement;
  isDefaultModal?: boolean;
}>`
  display: flex;
  flex-wrap: nowrap;
  justify-content: ${({ leftFooterElements }) =>
    leftFooterElements ? "space-between" : "flex-end"};
`;
const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
`;
